module.exports = __webpack_public_path__ + "img/robot_1.0b366669.png";